// Einstieg für den Messe-Kiosk (/kiosk).
import { KioskApp } from "./kiosk/app.js"

const root = document.getElementById("kiosk")
if (root) {
  const app = new KioskApp(root)
  app.start()
}
